import styled from '@emotion/styled';

export const Logotype = styled.p`
	pointer-events: none;
	justify-content: center;
	text-transform: uppercase;
	color: ${p => p.theme.colors.textMain};
	padding: 16px 0px;
	font-weight: 400;
	font-style: 20px;

	font-family: 'Abril Fatface';
`;
